import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/template/field/type/data/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/template/field/type/data/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/template/field/type/data/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/template/field/type/data/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/template/field/type/data/delete/batch', {
    params: {
      ids
    }
  })
}
